import { ReactNode } from "react";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  /** Optional title for the modal (used for aria-labelledby and as visual heading when provided) */
  title?: string;
  children: ReactNode;
  /** When true, clicking the overlay calls onClose. Default false. */
  closeOnOverlayClick?: boolean;
  /** Max width of the content panel. Default "max-w-lg". Use "max-w-2xl" or "max-w-3xl" for wider forms. */
  maxWidth?: "max-w-md" | "max-w-lg" | "max-w-2xl" | "max-w-3xl";
}

export default function Modal({
  isOpen,
  onClose,
  title,
  children,
  closeOnOverlayClick = false,
  maxWidth = "max-w-lg",
}: ModalProps) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent
        maxWidth={maxWidth}
        onPointerDownOutside={closeOnOverlayClick ? undefined : (e) => e.preventDefault()}
        onInteractOutside={closeOnOverlayClick ? undefined : (e) => e.preventDefault()}
      >
        {title ? (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
        ) : (
          <VisuallyHidden.Root asChild>
            <DialogTitle>Modal</DialogTitle>
          </VisuallyHidden.Root>
        )}
        <VisuallyHidden.Root asChild>
          <DialogDescription>
            {title || "Dialog content"}
          </DialogDescription>
        </VisuallyHidden.Root>
        {children}
      </DialogContent>
    </Dialog>
  );
}
